// Full names, not two-letter codes. Every order in the database stores the full name, and the
// orders list filters on that value - a mix of "AB" and "Alberta" makes the column unusable.
const PROVINCES = [
  'Alberta',
  'British Columbia',
  'Manitoba',
  'New Brunswick',
  'Newfoundland and Labrador',
  'Northwest Territories',
  'Nova Scotia',
  'Nunavut',
  'Ontario',
  'Prince Edward Island',
  'Quebec',
  'Saskatchewan',
  'Yukon',
];

export default PROVINCES;
